import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Alert from 'react-s-alert'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ThreadLogo from './assets/ThreadLogo'
import ThreadReminders from './assets/ThreadReminders'
import * as AccountActions from '../state/actions/account'
import './Login.css'

const styles = {
  page: {
    position: 'absolute',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#455A64',
    backgroundSize: 'cover',
    zIndex: 1000,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  loginFormContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '20px 0 0 0',
    height: '250px',
    width: '250px',
    borderRadius: '3px',
    backgroundColor: 'rgba(0,0,0,0.20)',
  },
  name: {
    color: '#533E2B',
    fontWeight: 'bold',
    fontSize: '1.1em',
  },
  logo: {
    height: '70px',
    width: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '50%',
  },
  inputFields: {
    backgroundColor: 'whitesmoke',
    padding: '5px',
    width: '200px',
    borderRadius: '3px',
    borderStyle: 'none',
    marginBottom: '5px',
  },
  submitButton: {
    background: 'white',
    color: '#3C9AC9',
    width: '30%',
    marginTop: '12px',
    borderRadius: '3px',
    borderStyle: 'none',
    padding: '2px',
    textTransform: 'uppercase',
  },
  forgotPassword: {
    color: '#bababa',
    marginTop: '12px',
    borderRadius: '3px',
    borderStyle: 'none',
    padding: '2px',
  },
}

class Login extends Component {

  static propTypes = {
    postUserLogin: PropTypes.func.isRequired,
  }

  state = {
    email: '',
    password: '',
    togglePasswordMessage: false,
  }

  handleEmail = (event) => {
    event.preventDefault()
    this.setState({ email: event.target.value })
  }

  handlePassword = (event) => {
    event.preventDefault()
    this.setState({ password: event.target.value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { email, password } = this.state

    this.props.postUserLogin(email, password)
    .then(() => {
      this.props.fetchCurrentUser()
    }).then(() => {
      const url = this.props.prevUrl || '/'
      this.props.history.push(url)
    }).catch(error => (
      Alert.warning(error.statusText, {
        position: 'top',
        effect: 'jelly',
        timeout: 5000,
      })
    ))
  }

  toggleMessage = (event) => {
    event.preventDefault()
    this.setState({ togglePasswordMessage: !this.state.togglePasswordMessage })
  }

  render() {
    return (
      <div className="login" style={styles.page}>
        <div style={styles.container}>
          <div className="loginFormContainer" style={styles.loginFormContainer}>
            <ThreadReminders />
            <ThreadLogo styles={styles.logo} height={'30px'} />
            <form style={styles.form} onSubmit={this.handleSubmit}>
              <input
                type="text"
                placeholder="email"
                style={styles.inputFields}
                onChange={this.handleEmail}
              />
              <input
                type="password"
                placeholder="password"
                style={styles.inputFields}
                onChange={this.handlePassword}
              />
              <input style={styles.submitButton} type="submit" value="go" />
            </form>
            <Alert stack={{ limit: 1 }} />
          </div>
          <div style={styles.forgotPassword}>
            <a style={{ color: '#47b9f2' }} href="" onClick={this.toggleMessage}>
              forgot password?
            </a>
            <p
              style={{
                visibility: this.state.togglePasswordMessage
                  ? 'visible'
                  : 'hidden',
              }}
            >
              Please email us at{' '}
              <a style={{ color: '#47b9f2' }} href="mailto:requests@roostergrin.com?subject=Thread password reset&body=Please reset the password for my account.">
                requests@roostergrin.com
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ account }) => ({
  prevUrl: account.auth.prevUrl,
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({ ...AccountActions }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js